import { getUrl } from "../utils/url";
import { fetchFromVolatileServer } from "../utils/fetchFromVolatileServer";
import { Post } from "./types/client";

export const hasCredentials = () => {
  return !!(process.env.BASIC_AUTH_USERNAME && process.env.BASIC_AUTH_PASSWORD);
};
export const fetchWithAuth = async (
  endpoint: string,
  locale?: string,
  defaultLocale?: string,
  additionalParams?: Record<string, string>,
): Promise<Post[]> => {
  try {
    const base64Credentials = btoa(
      `${process.env.BASIC_AUTH_USERNAME}:${process.env.BASIC_AUTH_PASSWORD}`,
    );
    const queryParams = new URLSearchParams(additionalParams || {}).toString();
    const url = `${getUrl(locale, defaultLocale)}${endpoint}${
      queryParams ? `?${queryParams}` : ""
    }`;

    const response = await fetchFromVolatileServer(url, {
      headers: {
        Authorization: `Basic ${base64Credentials}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch ${url}: ${response.status} ${response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      console.error(`Error in fetchWithAuth: ${error.message}`);
      return [];
    } else {
      console.error("An unknown error occurred in fetchWithAuth");
      return [];
    }
  }
};
